 <!-- Features -->
 <div class="cd-section" id="features" style="background-color: white;">
    <div class="container">
      <div class="features-2">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title-difference">Become a Compliance Hero Today!</h2>
            <h5 class="description" style="font-size: 20px;">With so many easy ways to get started, don't wait another minute to start saving money, reducing your risk, and accelerating your business.  Take your first step towards Continuous Compliance Automation and your RegOps journey by choosing from the options below:</h5>
          </div>
        </div>
        <div class="row col-md-12">
            <div class="col-md-6">
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="fas fa-tv"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Schedule a Live Demo</h4>
                  <p style="font-size: 20px;">Get your questions answered by our world class compliance professionals.</p>
                  <a href="https://meetings.hubspot.com/regops/regscale-exploratory-discussion" target="_blank" class="btn btn-rose btn-raised btn-round ">
                      Schedule Online
                    </a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="fas fa-box"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Play in the Sandbox</h4>
                  <p style="font-size: 20px;">Play for free in our cloud sandbox to get hands-on experience with no obligation.</p>
                  <a [routerLink]="['/gatekeeper/sandbox']" class="btn btn-rose btn-raised btn-round ">
                    Request Account
                  </a><br/>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-md-12">
            <div class="col-md-6">
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="fas fa-download"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Download Community Edition (CE) for Free</h4>
                  <p style="font-size: 20px;">Download and install RegScale CE to get started for free.</p>
                  <a [routerLink]="['/gatekeeper/download']" class="btn btn-rose btn-raised btn-round ">
                      Download Container
                    </a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="fas fa-dollar-sign"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Purchase Enterprise Edition (EE)</h4>
                  <p style="font-size: 20px;">Learn about our deployment options for enterprise customers.</p>
                  <a [routerLink]="['/gatekeeper/appliance']" class="btn btn-rose btn-raised btn-round ">
                      Contact Us
                    </a>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>


